import { Flex, Image } from "@chakra-ui/react";
import HeaderCell from "components/table/HeaderCell";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";

const columns = [
  //   {
  //     name: <HeaderCell label={"Id"} />,
  //     selector: (row) => row.id,
  //     // width: "180px",
  //   },
  {
    name: <HeaderCell label={"SKU"} />,
    selector: (row) => row?.variants?.sku,
    // width: "180px",
  },
  {
    name: <HeaderCell label={"Product Title"} />,
    selector: (row) => row.product_title,
  },
  {
    name: <HeaderCell label={"ACTION"} />,
    selector: (row) => row?.action,
    width: "160px",
  },
];

const data = [
  {
    id: 100,
    old_sku: 12445,
    product_title: "Product title",
    seller_id: 3,
    seller_name: "John Doe",
    address: "label",
    postcode: "label",
    // action: (
    //   <Flex alignItems={"center"}>
    //     <Image
    //       src={require("assets/svgs/eye.svg").default}
    //       onClick={() => {}}
    //       _hover={{ cursor: "pointer" }}
    //     />
    //   </Flex>
    // ),
  },
  {
    id: 101,
    old_sku: 122445,
    product_title: "Product title",
    seller_id: 5,
    seller_name: "John Doe wills",
    address: "label",
    postcode: "label",
    // action: (
    //   <Flex alignItems={"center"}>
    //     <Image
    //       src={require("assets/svgs/eye.svg").default}
    //       onClick={() => {}}
    //       _hover={{ cursor: "pointer" }}
    //     />
    //   </Flex>
    // ),
  },
];

const sort = (data, sortOrder) => {
  if (!data) return [];
  if (!sortOrder) return data;
  let sortedData = [...data];
  if (sortOrder === SORT_NEWEST_FIRST) {
    return sortedData.sort((a, b) => {
      if (a?.product_title?.toLowerCase() < b?.product_title?.toLowerCase())
        return 1;
      if (a?.product_title?.toLowerCase() > b?.product_title?.toLowerCase())
        return -1;
    });
  }
  if (sortOrder === SORT_OLDEST_FIRST) {
    return sortedData.sort((a, b) => {
      if (a?.product_title?.toLowerCase() > a?.product_title?.toLowerCase())
        return 1;
      if (a?.product_title?.toLowerCase() < b?.product_title?.toLowerCase())
        return -1;
    });
  }
};

const search = (data, searchQuery) => {
  if (!data) return [];
  if (searchQuery === "") return data;
  const results = data.filter((product) => {
    if (product?.seller_id?.toString()?.includes(searchQuery)) return true;
    if (product?.product_name?.toLowerCase()?.includes(searchQuery))
      return true;
    if (product?.seller_name?.toLowerCase()?.includes(searchQuery)) return true;
    if (product?.address?.toLowerCase()?.includes(searchQuery)) return true;
    if (product?.postcode?.toLowerCase()?.includes(searchQuery)) return true;
  });
  return results;
};

export { data, columns, sort, search };
